import { isEmpty } from 'lodash';
import styled from 'styled-components';
import Tooltip from '../../../ToolTip';
import { Row } from '../../styles';

export const columns = [
  {
    Header: 'Criteria',
    accessor: 'criteria',
    classes: 'td-criteria',
    getCustomStyles: () => ({
      display: 'none',
    }),
    Cell: '',
  },
  {
    Header: 'Phase',
    accessor: 'phase',
    getCustomStyles: () => ({
      width: '8rem',
      display: 'none',
    }),
    Cell: ({ row: { original }, popupInfoObj }) => (
      <Tooltip
        triggerComponent={() => {
          const phaseName = popupInfoObj[original.phase]?.phaseName;
          return (
            <PhaseWrapper>
              <span>Phase {original.phase}</span>
              {phaseName && <span> {phaseName}</span>}
            </PhaseWrapper>
          );
        }}
        contentComponent={() => {
          const popupInfo = getPopupInfoToDisplay(popupInfoObj, original.phase, ['name']);
          return (
            <ProjectInfoPopupWrapper>
              {popupInfo?.map(
                ({ label, value }) =>
                  value && (
                    <Row
                      marginBottom='0.5rem'
                      key={label}>
                      <PopupLabel>{label}:</PopupLabel>
                      <PopupValue>{value}</PopupValue>
                    </Row>
                  )
              )}
            </ProjectInfoPopupWrapper>
          );
        }}
      />
    ),
  },
  {
    Header: 'Score',
    accessor: 'score',
    getCustomStyles: () => ({
      width: '5rem',
      display: 'none',
    }),
    Cell: ({ value }) => `${value || '-'}%`,
  },
  {
    Header: 'Reasoning',
    accessor: 'reasoning',
    getCustomStyles: () => ({
      display: 'none',
      //   width: '33%',
      // width: 'calc(100% - 25rem)',
      // width: '35%',
      //   display: 'none',
    }),
  },
];

const constructInfoObj = (label, value) => ({
  label: label,
  value: value,
});

const getPopupInfoToDisplay = (popupInfoObj, phaseNum, valuesToDisplay) => {
  const info = [];
  const phaseInfo = popupInfoObj[phaseNum];
  if (!valuesToDisplay || valuesToDisplay?.includes('name')) {
    info.push(constructInfoObj('Project Name', phaseInfo?.name));
  }
  if (!valuesToDisplay || valuesToDisplay?.includes('phaseName')) {
    info.push(constructInfoObj('Phase Description', phaseInfo?.phaseName));
  }

  return info;
};

const ProjectInfoPopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const PhaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  > *:not(:last-child) {
    margin-bottom: 0.25rem;
  }
`;

const PopupLabel = styled.span`
  margin-right: 0.5rem;
  font-size: 0.75rem;
`;

const PopupValue = styled.span`
  max-width: 200px;
  font-size: 0.75rem;
  font-weight: 600;
`;
